import { Row } from "../components/Layout";
import React, {useEffect} from "react";
import {Orders} from "./orders";
import {bindActionCreators} from "redux";
import {useDispatch} from "react-redux";

const loadOrders = (props) => {
    return (
        <div className="container-fluid min-h-[350px] ">
            <div className=" rounded-xl mx-2 border-2 border-solid border-gray-400">
                <Orders></Orders>
            </div>
        </div>
    );
};

export default loadOrders;